import {useEffect,useState} from 'react';
import {traderAPI,useTraderAuth} from '../context/TraderAuthContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';
export const useDepositHistory=(account,page,version)=>{
  const {user}=useTraderAuth(),[state,setState]=useState({loading:true,data:null,error:false});
  useEffect(()=>{
    let live=true,pending=false;const controller=new AbortController();
    setState({loading:true,data:null,error:false});
    if(!account)return()=>controller.abort();
    const load=async()=>{if(pending)return;pending=true;try{const {data}=await traderAPI.get(`/api/trader/deposit-requests?${new URLSearchParams({account_id:account,page:String(page)})}`,{signal:controller.signal,timeout:20000});if(live)setState({loading:false,data,error:false});}catch(e){if(live)setState({loading:false,data:null,error:true});}finally{pending=false;}};
    load();const stop=watchLiveRefresh(load);
    return()=>{live=false;stop();controller.abort();};
  },[account,page,version,user?.id]);
  return state;
};